/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
import React from 'react';
import _ from 'utils/lodash';
import { BusinessType } from 'enums/common';
import { BTTService } from 'types/campaign';
import BttServicesSelect from '../offerEditor/bttServicesSelect';
import './inputServices.scss'; //comment to make sure new commit is made

interface Props {
  value?: {
    title: string;
    type: string;
    info?: string;
    links: {
      url?: string;
      text?: string;
    }[];
    linkURLSelected?: string;
    linkTextSelected?: string;
  };
  onChange({
    title,
    type,
    info,
    links,
    linkURLSelected,
    linkTextSelected,
  }: {
    title: string;
    type: string;
    info?: string;
    links: { url?: string; text?: string }[];
    linkURLSelected?: string;
    linkTextSelected?: string;
  }): void;
  label?: string;
  readOnly?: boolean;
  name: string;
  targetGroupType?: BusinessType;
}

interface State {
  local: {
    title: string;
    type: string;
    info?: string;
    links: { url?: string; text?: string }[];
    linkURLSelected?: string;
    linkTextSelected?: string;
  };
}

class InputServices extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      local: {
        title: props.value?.title || '',
        type: props.value?.type || '',
        info: props.value?.info || '',
        links: props.value?.links ? [...props.value.links] : [],
        linkURLSelected: props.value?.linkURLSelected || '',
        linkTextSelected: props.value?.linkTextSelected || '',
      },
    };
  }

  componentDidUpdate(prev: Props) {
    if (prev.value !== this.props.value) {
      this.setState({
        local: {
          title: this.props.value?.title || '',
          type: this.props.value?.type || '',
          info: this.props.value?.info || '',
          links: this.props.value?.links ? [...this.props.value.links] : [],
          linkURLSelected: this.props.value?.linkURLSelected || '',
          linkTextSelected: this.props.value?.linkTextSelected || '',
        },
      });
    }
  }

  emitChange(updatedLocal: State['local']) {
    this.setState({ local: updatedLocal });
    this.props.onChange(updatedLocal);
  }

  onServicesSelect = (s: BTTService) => {
    const mappedUrl = s.linkUrls?.[0] || s.links?.[0]?.url;
    const payload = {
      title: s.title,
      type: s.type,
      info: s.info,
      linkURLSelected: mappedUrl,
      linkTextSelected: s.links[0]?.text,
      links: mappedUrl ? [{ url: mappedUrl, text: s.links?.[0]?.text }] : s.links || [],
    };
    const updated = { ...(this.state.local || {}), ...payload };
    this.emitChange(updated);
  };

  handleFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const updated = { ...this.state.local, [name]: value };
    this.emitChange(updated);
  };

  // Links array helpers
  addLink = () => {
    const links = Array.isArray(this.state.local.links) ? [...this.state.local.links] : [];
    links.push({ url: '', text: '' });
    const updated = { ...this.state.local, links };
    this.emitChange(updated);
  };

  removeLink = (index: number) => {
    const links = Array.isArray(this.state.local.links) ? [...this.state.local.links] : [];
    links.splice(index, 1);
    // If removed link was selected, clear linkURLSelected and linkTextSelected
    let linkURLSelected = this.state.local.linkURLSelected;
    let linkTextSelected = this.state.local.linkTextSelected;
    if (
      linkURLSelected === this.state.local.links[index]?.url &&
      linkTextSelected === this.state.local.links[index]?.text
    ) {
      linkURLSelected = undefined;
      linkTextSelected = undefined;
    }
    const updated = { ...this.state.local, links, linkURLSelected, linkTextSelected };
    this.emitChange(updated);
  };

  handleLinkUrlChange = (index: number, value: string) => {
    const links = Array.isArray(this.state.local.links) ? [...this.state.local.links] : [];
    links[index] = { ...(links[index] || {}), url: value };
    const updated = { ...this.state.local, links };
    this.emitChange(updated);
  };

  handleLinkTextChange = (index: number, value: string) => {
    const links = Array.isArray(this.state.local.links) ? [...this.state.local.links] : [];
    links[index] = { ...(links[index] || {}), text: value };
    const updated = { ...this.state.local, links };
    this.emitChange(updated);
  };

  handleLinkSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedIndex = Number(e.target.value);
    const selectedLink = this.state.local.links[selectedIndex];
    const updated = {
      ...this.state.local,
      linkURLSelected: selectedLink?.url,
      linkTextSelected: selectedLink?.text,
    };
    this.emitChange(updated);
  };

  // collect candidate URLs for link datalist
  getCandidateUrls(): string[] {
    const set = new Set<string>();
    const links = Array.isArray(this.state.local.links) ? this.state.local.links : [];
    links.forEach((l) => l.url && set.add(l.url));
    const raw = (this.state.local as any).linkURLs;
    if (Array.isArray(raw)) raw.forEach((u: any) => u && set.add(String(u)));
    return Array.from(set);
  }

  renderLinksEditor() {
    const links: { url?: string; text?: string }[] = Array.isArray(this.state.local.links)
      ? this.state.local.links
      : [];
    const linkURLSelected = this.state.local.linkURLSelected;
    return (
      <div className="form-control">
        <label>Linkit</label>
        {links.map((l, i) => {
          const datalistId = `service-links-${this.props.name}-${i}`;
          return (
            <div key={`link-${i}`} style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center' }}>
              <div style={{ flex: 1 }}>
                <input
                  list={datalistId}
                  value={l.url || ''}
                  onChange={(e) => this.handleLinkUrlChange(i, e.target.value)}
                  placeholder="URL"
                  readOnly={this.props.readOnly}
                  style={{ width: '100%' }}
                />
                <datalist id={datalistId}>
                  {links.map((link, idx) =>
                    link.url ? <option value={link.url} key={`${datalistId}-opt-${idx}`} /> : null,
                  )}
                </datalist>
              </div>

              <div style={{ flex: 1 }}>
                <input
                  value={l.text || ''}
                  onChange={(e) => this.handleLinkTextChange(i, e.target.value)}
                  placeholder="Linkkiteksti"
                  readOnly={this.props.readOnly}
                  style={{ width: '100%' }}
                />
              </div>

              {!this.props.readOnly && (
                <button type="button" onClick={() => this.removeLink(i)} aria-label={`remove-link-${i}`}>
                  ×
                </button>
              )}
            </div>
          );
        })}

        {/* Select box for choosing the active link */}
        {links.length > 0 && (
          <div style={{ marginTop: 8 }}>
            <label>Valitse linkki</label>
            <select
              value={links.findIndex((l) => l.url === linkURLSelected)}
              onChange={this.handleLinkSelect}
              disabled={this.props.readOnly}
            >
              <option value={-1}>-- Valitse --</option>
              {links.map((l, i) => (
                <option key={`link-opt-${i}`} value={i}>
                  {l.url || ''}
                </option>
              ))}
            </select>
            {/* Display and allow editing of selected link text */}
            {typeof linkURLSelected === 'string' && linkURLSelected !== '' && (
              <div style={{ marginTop: 8 }}>
                <label>Valitun linkin teksti</label>
                <input
                  value={this.state.local.linkTextSelected || ''}
                  onChange={(e) => {
                    const updated = { ...this.state.local, linkTextSelected: e.target.value };
                    this.emitChange(updated);
                  }}
                  readOnly={this.props.readOnly}
                  style={{ width: '100%' }}
                />
              </div>
            )}
          </div>
        )}

        {!this.props.readOnly && (
          <div>
            <button type="button" onClick={this.addLink}>
              Lisää linkki
            </button>
          </div>
        )}

        {links.length === 0 && <div className="no-results">Ei linkkejä.</div>}
      </div>
    );
  }

  render() {
    const v = this.state.local;
    return (
      <div className="service-input">
        {this.props.label && <label>{this.props.label}</label>}

        {/* Dropdown for selecting services */}
        <div className="form-control">
          <BttServicesSelect
            onSelect={this.onServicesSelect}
            placeholder="Kirjoita väh. 1 merkki..."
            targetGroupType={this.props.targetGroupType}
          />
        </div>

        <div className="form-control">
          <label>Palvelu</label>
          <input name="title" value={v.title || ''} onChange={this.handleFieldChange} readOnly={this.props.readOnly} />
        </div>

        <div className="form-control">
          <label>Palvelut info</label>
          <input name="info" value={v.info || ''} onChange={this.handleFieldChange} readOnly={this.props.readOnly} />
        </div>

        <div className="form-control" hidden>
          <label>Palvelut linkki teksti</label>
          <input
            name="linkTextSelected"
            value={v.linkTextSelected || ''}
            onChange={this.handleFieldChange}
            readOnly={this.props.readOnly}
          />
        </div>

        <div className="form-control" hidden>
          <label>Palvelut linkki</label>
          <input
            name="linkURLSelected"
            value={v.linkURLSelected || ''}
            onChange={this.handleFieldChange}
            readOnly={this.props.readOnly}
          />
        </div>
      </div>
    );
  }
}

export default InputServices;
